import React from 'react';
import { Icon, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { SettingsHeading } from '../../../SidebarMenu/styles';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';
import PdfQualitySelection from '../PdfQualitySelection';
import { usePdfQualitySettings } from '../hooks/usePdfQualitySettings';
import { checkSessionUserAccess } from '../../../../utils/helper';
import { useSessionContext } from '../../../../context/sessionContext';
import { useArtboardContext, CONTEXT_KEYS } from '../../../../context/complexArtboardContext';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

export const PdfQualitySection = ({ readOnly, showTooltip = true, customStyles }) => {
  const { t } = useTranslation(NAMESPACES);
  const { pdfQuality, onPdfQualityChange } = usePdfQualitySettings();

  const sessionSelector = React.useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  const readonlySelector = React.useCallback(store => store[CONTEXT_KEYS.READONLY_TEMPLATE], []);
  const [readOnlyFromContext] = useArtboardContext(readonlySelector, 'PdfQualitySection');
  const effectiveReadOnly = readOnly !== undefined ? readOnly : readOnlyFromContext;

  if (!checkSessionUserAccess(userDetails, 'master')) {
    return (
      <SettingsHeading complexDesign style={customStyles}>
        {t(
          DESIGN_AREA_SETTINGS_TAB.PDF_QUALITY_LABEL.key,
          DESIGN_AREA_SETTINGS_TAB.PDF_QUALITY_LABEL.value,
        )}{' '}
        {showTooltip && (
          <Tooltip
            placement="topLeft"
            title={t(
              DESIGN_AREA_SETTINGS_TAB.PDF_QUALITY_TOOLTIP.key,
              DESIGN_AREA_SETTINGS_TAB.PDF_QUALITY_TOOLTIP.value,
            )}
          >
            <Icon type="question-circle" />
          </Tooltip>
        )}
        <PdfQualitySelection selectedQuality={pdfQuality} onChange={onPdfQualityChange}/>
      </SettingsHeading>
    );
  }

  return null;
};


